import { Axios } from "@/utils/axios";

type PriorityTier = 1 | 2 | 3 | 4;

const PRIORITY_SUBTEAM_MENTION = "<!subteam^S0BA57KDEK1>";
const PRIORITY_MENTION_MAX_TIER: PriorityTier = 3;

// (entry, question) 조합별 우선순위. entry는 buildCallLeadMemo의 trigger, question은 reason (없으면 "X").
const PRIORITY_MAP: Record<string, Record<string, PriorityTier>> = {
  "가입 중 이탈 시도": { X: 1 },
  "결제 실패 페이지": { X: 1 },
  "랜딩페이지 상담요청": {
    "기타 문의가 있어요.": 1,
    "전화로 가입하고 싶어요.": 2,
    "상품 설명을 더 자세히 듣고 싶어요.": 3,
    "다른 상조와 어떤 차이가 있는지 알고 싶어요.": 3,
  },
  "상담 신청 페이지": {
    "기타 문의가 있어요.": 1,
    "다른 상조와 어떤 차이가 있는지 알고 싶어요.": 2,
    "전화로 가입하고 싶어요.": 2,
    "상품 설명을 더 자세히 듣고 싶어요.": 3,
  },
  "회사 소개 페이지": { X: 1 },
  "결제 전 상품 선택": {
    "전화로 가입하고 싶어요.": 2,
    "상품 설명을 더 자세히 듣고 싶어요.": 3,
    "기타 문의가 있어요.": 4,
    "다른 상조와 어떤 차이가 있는지 알고 싶어요.": 4,
  },
  "본인인증 도움 요청": { "휴대폰 본인인증이 어려워요": 2 },
  "trust-intro 페이지에서 상담 요청": { X: 2 },
  "리드폼 랜딩": {
    "다른 상조와 비교해보고 싶어요": 4,
    "100원 상조 설명을 듣고 싶어요": 4,
  },
  "FAQ 페이지": { X: 4 },
  "trust_btm 신뢰 배너 상담 신청": { X: 4 },
};

function getPriorityTier(memo: string): PriorityTier | null {
  const trigger = memo.match(/\[상담 진입\] (.+)/)?.[1];
  const reason = memo.match(/\[고객 질문\] (.+)/)?.[1];
  if (!trigger || !reason) return null;
  return PRIORITY_MAP[trigger]?.[reason] ?? null;
}

export function withPriorityTag(memo: string): string {
  const tier = getPriorityTier(memo);
  if (!tier || tier > PRIORITY_MENTION_MAX_TIER) return memo;

  const tag = `[상담 우선순위 ${tier}]`;
  return `${PRIORITY_SUBTEAM_MENTION} ${tag}\n${memo}`;
}

export const postPrimeCallLead = async (
  phone: string,
  text: string,
  marketingConsent: boolean
): Promise<number> => {
  const data = {
    phone,
    memo: withPriorityTag(text),
    marketing_consent: marketingConsent,
  };

  try {
    const res = await Axios.post("/advance_pay_customers/call_leads/", data);
    return res.data.id as number;
  } catch (error) {
    console.error("상담 제출에 실패하였습니다.", error);
    throw error;
  }
};
